export default "__VITE_ASSET__6lYKT$Xf__"